export enum PictogramNameType {
    Price = "Cena",
    ConstructionEndDate = "Termin Oddania",
    Rooms = "Pokoje",
    Area = "Metraż",
    Floor = "Piętro",
    WorldSide = "Strona świata",
    AdditionalArea = "Dodatkowe",
    Kitchen = "Kuchnia",
    HeightRange = "Wysokość pomieszczeń",
    Floors = "Ilość kondygnacji",
    OfferNumber = "Oznaczenie oferty"
}
export enum PictogramNameType {
    Price = "Cena",
    ConstructionEndDate = "Termin Oddania",
    Rooms = "Pokoje",
    Area = "Metraż",
    Floor = "Piętro",
    WorldSide = "Strona świata",
    AdditionalArea = "Dodatkowe",
    Kitchen = "Kuchnia",
    HeightRange = "Wysokość pomieszczeń",
    Floors = "Ilość kondygnacji",
    OfferNumber = "Oznaczenie oferty"
}
